import type { HTMLAttributes } from 'react';

import '@/components/shared/spinners/small-spinner.css';

const SmallSpinner = (props: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div id={'spinner'} role="status" aria-live="polite" aria-label="Chargement en cours" {...props}>
            <span className={'dot'} aria-hidden="true" />
            <span className={'dot'} aria-hidden="true" />
            <span className={'dot'} aria-hidden="true" />
        </div>
    );
};

export default SmallSpinner;
